/* eslint-disable */

export default {
	init() {
		// JavaScript to be fired on the home page
	},
	finalize() {

		$('[data-fancybox="gallery"]').fancybox({
			touch: false,
			loop: true,
			thumbs: {
				autoStart: true
			},

			afterClose: function (instance, slide) {
				$('.single-product-slider').not('.slick-initialized').slick('slickGoTo', slide.index, true);
			}
		});

		const images = $('.single-product-slider');
		if (images) {
			var slider = $('.single-product-slider').not('.slick-initialized').slick({
				prevArrow: $('.previous-nav > .slick-prev'),
				nextArrow: $('.next-nav > .slick-next'),
				infinite: true,
				arrows: true,
				speed: 800,
				slidesToShow: 1,
				asNavFor: '.single-product-image-thumbs',
			})
		}

		const thumbs = $('.single-product-image-thumbs')
		if (thumbs) {
			var sliderThumbs = $('.single-product-image-thumbs').not('.slick-initialized').slick({
				infinite: true,
				arrows: false,
				speed: 800,
				slidesToShow: 10,
				// slidesToScroll: 10,
				variableWidth: true,
				focusOnSelect: true,
				asNavFor: '.single-product-slider',
			})

		}

		const dimenensionsEl = document.querySelector('.dimensions')
		if (dimenensionsEl) {
			$('.dimensions').not('.slick-initialized').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: true,
				infinite: true,
				variableWidth: true,
				centerMode: false,
				speed: 300,
				cssEase: 'ease',
				prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-disabled="false" style="display: inline;"><g transform="translate(0 24) rotate(-90)"><rect width="24" height="24" fill="#14181e" opacity="0"></rect><g transform="translate(5 8)"><path d="M7,0a1,1,0,0,0-.707.293l-6,6A1,1,0,0,0,1.707,7.707L7,2.414l5.293,5.293a1,1,0,1,0,1.414-1.414l-6-6A1,1,0,0,0,7,0Z" fill="#14181e"></path></g></g></svg>',
				nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-disabled="false" style="display: inline;"><g transform="translate(0 24) rotate(-90)"><rect width="24" height="24" fill="#14181e" opacity="0"></rect><g transform="translate(5 8)"><path d="M12,16a1,1,0,0,1-.707-.293l-6-6A1,1,0,1,1,6.707,8.293L12,13.586l5.293-5.293a1,1,0,0,1,1.414,1.414l-6,6A1,1,0,0,1,12,16Z" transform="translate(-5 -8)" fill="#14181e"></path></g></g></svg>',
				touchThreshold: 100,
				responsive: [
					{
						breakpoint: 1520,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							centerMode: true,
						},
					}],
			})

		}

		const colorisEl = document.querySelector('.coloris')
		if (colorisEl) {
			$('.coloris').not('.slick-initialized').slick({
				slidesToShow: 5,
				slidesToScroll: 1,
				arrows: true,
				infinite: true,
				variableWidth: true,
				centerMode: false,
				speed: 300,
				cssEase: 'ease',
				prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-disabled="false" style="display: inline;"><g transform="translate(0 24) rotate(-90)"><rect width="24" height="24" fill="#14181e" opacity="0"></rect><g transform="translate(5 8)"><path d="M7,0a1,1,0,0,0-.707.293l-6,6A1,1,0,0,0,1.707,7.707L7,2.414l5.293,5.293a1,1,0,1,0,1.414-1.414l-6-6A1,1,0,0,0,7,0Z" fill="#14181e"></path></g></g></svg>',
				nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-disabled="false" style="display: inline;"><g transform="translate(0 24) rotate(-90)"><rect width="24" height="24" fill="#14181e" opacity="0"></rect><g transform="translate(5 8)"><path d="M12,16a1,1,0,0,1-.707-.293l-6-6A1,1,0,1,1,6.707,8.293L12,13.586l5.293-5.293a1,1,0,0,1,1.414,1.414l-6,6A1,1,0,0,1,12,16Z" transform="translate(-5 -8)" fill="#14181e"></path></g></g></svg>',
				touchThreshold: 100,
				responsive: [
					{
						breakpoint: 1680,
						settings: {
							slidesToShow: 4,
						},
					},
					{
						breakpoint: 1520,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
						},
					}],
			})

		}


	},

}


// WEBPACK FOOTER //
// ./scripts/routes/singleProduit.js


// WEBPACK FOOTER //
// ./scripts/routes/singleProduit.js